// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"570":"5b130e40","578":"da921874","722":"2f7b6641","788":"3a7e137a","986":"1d2fc844"}[chunkId] + ".chunk.js";
};